module.exports = __webpack_public_path__ + "static/img/rrrr_06.c479fbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_06.png
// module id = +5JR
// module chunks = 1